<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      
      
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="crumps"
        title="View Sub Category Details"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>
      <div class="componet-has-nav-bar white pt-5">
        <CardedSectionHeader
          icon="mdi-group"
          label="Sub Category Details"
          id="public_sub_category_details_section"
        ></CardedSectionHeader>
        <CardedDisplay>
          <div class="pa-5">
            <ViewHeader
              :title="sub_category.name"
              :icon="sub_category.icon"
              :img_src="sub_category.thumb_nail"
              :facts="view_header_facts"
              :description="sub_category.description"
            ></ViewHeader>
          </div>
        </CardedDisplay>
        <CardedSectionHeader
          icon="mdi-home-city-outline"
          label="Businesses In This Sub Category"
          id="public_sub_category_businesses_alpha_section"
        ></CardedSectionHeader>
        <CardedTable
          :items="businesses"
          :headers="business_headers"
          :show_description="true"
          :has_margin="false"
        >
          <template v-slot:description>
            <p class="text-left ml-4 mr-4">
              This Sub Category has {{ businesses.length }} businesses
            </p>
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <div
            style="max-width: 300px; font-size: 13px"
            class="text-left text-truncate"
          >{{item.description}}</div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              @click="view_business(item)"
              x-small
              rounded
              text
              color="success"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </CardedTable>
      </div>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CenterNavbar from "./../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";
import ViewHeader from "./../../components/ViewHeader";
import CardedDisplay from "./../../components/CardedDisplay";
import CardedTable from "./../../components/CardedTable";
import QuickSideLinks from "./../../components/QuickSideLinks";


import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
export default {
  name: "SubCategory",
  components: {
    Page,
    SidePageColumn,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer,
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    CardedTable,
    QuickSideLinks
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "sub_category_view",
    page_info: page_info,
    category_id: 0,
    sub_category_id: 0,
    sub_category: Utils.get_default_page_sub_category(),
    businesses: [],
    business_headers: [
      { text: "Name", value: "name" },
      { text: "District", value: "district.name", sortable: false },
      { text: "More", value: "description", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
    quick_links: [
      {
        text: "Sub Category",
        href: "#public_category_details_section",
      },
      {
        text: "Businesses",
        href: "#public_sub_category_businesses_alpha_section",
      }
    ],
    crumps: []
  }),
  methods: {
    load_category() {
      this.$emit("on-show-loader");
      ServerClient.Categories.fetch_sub_category_page(
        {
          id: this.sub_category_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          
          this.sub_category = res.sub_category;
          this.businesses = res.businesses;


          var vm = this;
          setTimeout(() => {
            vm.go_to_section("public_sub_category_details_section");
          }, 1000);
        },
        (errors) => {
          console.log(
            "Errors loading sub category details on public sub category page: ",
            errors
          );
          this.$emit("on-hide-loader");
        }
      );
    },
    go_to_section(alpha) {
      this.selected_alpha = alpha;
      this.scroll_to_secton(alpha);
    },
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    scroll_to_secton(lmnt_id) {
      try {
        var options = {
          offset: 50,
          duration: 1000,
          easing: "easeInOutCubic",
        };
        this.$vuetify.goTo("#" + lmnt_id, options);
      } catch (error) {
        console.log("Error scrolling to section on sub category page ", error);
      }
    },
    view_business(business){
      this.$router.push('/businesses/'+business.id);
    }
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Category :",
          val: this.sub_category.category.name,
        },
        {
          text: "Businesses :",
          val: this.comma(this.sub_category.businesses_count),
        }
      ];
      return facts;
    },
  },
  mounted() {
    this.sub_category_id = parseInt(this.$route.params.id);
    this.category_id = parseInt(this.$route.params.cat_id);
    this.crumps = [{
      text: "Categories",
      disabled: false,
      href: "/categories",
    },{
      text: "Category",
      disabled: false,
      href: "/categories/" + this.category_id,
    },{
      text: "Sub Category",
      disabled: true,
      href: "/categories/" + this.category_id + "/sub/" + this.sub_category_id,
    }];
    this.load_category();
  },
};
</script>